import axios, { AxiosResponse } from "axios";

export const $getStrData = (url: string): Promise<string> => axios
	.get(url, { responseType: 'text' })
	.then((r: AxiosResponse<string>) => (r ? r.data : '') || '')
	.catch(() => '');

export const $getBlobData = (url: string): Promise<Blob | null> => axios
	.get(url, { responseType: 'blob' })
	.then((r: AxiosResponse<Blob | null>) => (r ? r.data : null) || null)
	.catch(() => null);

export const fillRequestData = <T extends FormData | URLSearchParams>(
	entity: T,
	obj: any,
	methodForAdd: keyof T = 'append'
): T => {
	for (let i in obj) (entity as any)[methodForAdd](i, obj[i]);

	return entity;
};

export const getURLSearchParamsByObj = (v: any): URLSearchParams =>
	fillRequestData(new URLSearchParams(), v);

export const getFormDataByObj = (v: any): FormData =>
	fillRequestData(new FormData(), v);

export const objectToFormdata = <T>(value: T): FormData => {
	const formData = new FormData();

	fillRequestData(formData, value);

	return formData;
};